__turbopack_context__.v({
  "className": "sora_e13310fc-module__MVUlWq__className",
});
